import { StyleDeclaration } from 'aphrodite/no-important';
import { SCREEN_SIZE_KEYS } from 'mm-theme-configuration/dist/consts';

export const ASPECT_RATIO_LAYOUT = 'aspect ratio layout' as const;
export const FULL_HEIGHT_LAYOUT = 'full height layout' as const;
export type BaseStyleTypes = typeof ASPECT_RATIO_LAYOUT | typeof FULL_HEIGHT_LAYOUT;

export type BaseStyleConfiguration = {
    [key in SCREEN_SIZE_KEYS]: BaseStyleTypes
}
export interface AspectRatio {
    x: number
    y: number
}

export interface CalculatedThumbnail {
    imageUrl: string
    srcSet: string
    sizes: string
    alt: string
    title: string
    lowResUrl?: string
}

export interface Thumbnail {
    host: string
    path: string
    description: string
    caption ?: string
    credit ?: string
    aspectRatio?: AspectRatio
    baseStyleConfiguration?: BaseStyleConfiguration
}

export interface imageStyleSheet {
    [key: string]: StyleDeclaration
}
